// extracted by mini-css-extract-plugin
export default {"canvas":"style_canvas__ghUSX","cursor":"style_cursor__HXj4i"};